export const ASSETS = {
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_1d516e54-fd6b-4559-97c3-f6d903e4f9b0/artifacts/r4stomcm_Ashley-Falls-PTA-Logo.png",
  plushie: "https://customer-assets-39nsmqrw.emergentagent.net/job_1d516e54-fd6b-4559-97c3-f6d903e4f9b0/artifacts/gf5h4qwx_Plushie%20Mockup.png",
};

export const TIERS = [
  {
    id: "general",
    name: "General",
    price: "$31",
    priceNote: "Single / $62 Dual",
    entries: 5,
    highlight: "Every Eagle family counts!",
    urlSingle: "https://www.ashleyfallspta.com/form/m/398522",
    urlDual: "https://www.ashleyfallspta.com/form/m/398524",
    perks: ["Covers your PTA dues", "Exclusive Eagle Keychain gift"],
    accent: "#38BDF8",
    glow: "rgba(56,189,248,0.35)",
    mascot:
      "https://static.prod-images.emergentagent.com/jobs/1d516e54-fd6b-4559-97c3-f6d903e4f9b0/images/9f8a80e8d459fcd1fcc24e5093276b1fff0944707c31711bd28f8d1599387b09.jpeg",
  },
  {
    id: "hawk",
    name: "Hawk",
    price: "$100",
    priceNote: null,
    entries: 20,
    highlight: "A flock favorite!",
    url: "https://www.ashleyfallspta.com/form/m/398520",
    perks: [
      "General membership included",
      "Student lunch with Principal Pecorella",
      "Also great for Grandparents!",
    ],
    accent: "#00F5D4",
    glow: "rgba(0,245,212,0.35)",
    mascot:
      "https://static.prod-images.emergentagent.com/jobs/1d516e54-fd6b-4559-97c3-f6d903e4f9b0/images/2c6e426e0bf546f68035e92d033a3392020954517056303364957cd8d12c9945.jpeg",
  },
  {
    id: "falcon",
    name: "Falcon",
    price: "$250",
    priceNote: null,
    entries: 35,
    highlight: "Soar even higher!",
    url: "https://www.ashleyfallspta.com/form/m/398782",
    perks: [
      "+$20 Spirit Wear Credit",
      "General Membership gift",
      "Student lunch with Mrs. Pecorella",
      "Access to the on-line school directory",
      "Special PTA giveaway per child",
      "Contributing member of your child's school and PTA",
    ],
    accent: "#F43F1A",
    glow: "rgba(244,63,26,0.35)",
    mascot:
      "https://static.prod-images.emergentagent.com/jobs/1d516e54-fd6b-4559-97c3-f6d903e4f9b0/images/fa0956b63ac680b5b9cbb58b5cf652a81ff5530bb3f50eba1495abc666f49479.jpeg",
  },
  {
    id: "eagle",
    name: "Eagle",
    price: "$500",
    priceNote: null,
    entries: 50,
    highlight: "Maximum impact giving!",
    url: "https://www.ashleyfallspta.com/form/m/398518",
    perks: ["Everything in Hawk", "Drop-off Eagle movie night"],
    accent: "#FF007F",
    glow: "rgba(255,0,127,0.4)",
    featured: true,
    badge: "Suggested Giving",
    mascot:
      "https://static.prod-images.emergentagent.com/jobs/1d516e54-fd6b-4559-97c3-f6d903e4f9b0/images/dde87a61eacd491231939dd7ea004a84fc0367745f66f491636e68edab292349.jpeg",
  },
  {
    id: "pelican",
    name: "Pelican",
    price: "$1000",
    priceNote: null,
    entries: 100,
    highlight: "Champion-level support!",
    url: "https://www.ashleyfallspta.com/form/m/398513",
    perks: [
      "Everything in Eagle",
      "Legacy Art Tile",
      "Drawing for 'Assistant Principal for an hour'",
    ],
    accent: "#D946EF",
    glow: "rgba(217,70,239,0.35)",
    mascot:
      "https://static.prod-images.emergentagent.com/jobs/1d516e54-fd6b-4559-97c3-f6d903e4f9b0/images/d74031caf6f2ca6537a62f33f6886805f3133774fa5a6c5a7a88567980113f10.jpeg",
  },
  {
    id: "condor",
    name: "Condor",
    price: "$2500",
    priceNote: null,
    entries: 200,
    highlight: "Legacy-level impact!",
    url: "https://www.ashleyfallspta.com/form/m/398509",
    perks: [
      "Everything in Pelican",
      "Evening family event",
      "$50 Spirit Wear credit",
    ],
    accent: "#B500FF",
    glow: "rgba(181,0,255,0.35)",
    mascot:
      "https://static.prod-images.emergentagent.com/jobs/1d516e54-fd6b-4559-97c3-f6d903e4f9b0/images/9fb8958227a6f825198cdb78f4386465af412557fdb04a9f3d2130a908116ded.jpeg",
  },
];

export const EXTRA_TIERS = [
  {
    id: "grandparents",
    name: "Grandparents",
    price: "$50",
    entries: 10,
    url: "https://www.ashleyfallspta.com/form/m/398521",
    highlight: "A gift that makes your Grandchild's school soar!",
    perks: ["A special way for Grandparents to support their Eagle"],
    accent: "#F59E0B",
    glow: "rgba(245,158,11,0.35)",
    mascot:
      "https://static.prod-images.emergentagent.com/jobs/1d516e54-fd6b-4559-97c3-f6d903e4f9b0/images/169e35b81a2db70f1773dd7e0799cce286adafc321e06296bf1c554266a50714.jpeg",
  },
  {
    id: "business",
    name: "Business",
    price: "$200",
    entries: null,
    url: "https://www.ashleyfallspta.com/form/m/398526",
    highlight: null,
    perks: [
      "General Membership gift",
      "Membership Plaque for your Business",
      "Logo on PTA Sponsor Website Page",
      "Contributing member of your community's school and PTA",
    ],
    accent: "#3B82F6",
    glow: "rgba(59,130,246,0.35)",
    mascot:
      "https://static.prod-images.emergentagent.com/jobs/1d516e54-fd6b-4559-97c3-f6d903e4f9b0/images/eb03178f2f5efed5ecb1a78b0205ea7148129295c78f57541134c7b79880e64f.jpeg",
  },
];

export const JOIN_URL = "https://www.ashleyfallspta.com/packet/t89305537";

export const ENTRY_TALLY_START = 250;

export const IMPACT = [
  {
    num: "01",
    title: "Academic & Classroom Support",
    icon: "GraduationCap",
    accent: "#00E5F0",
    items: [
      "Classroom Mini Grants ($12k last year — wow!)",
      "Literary Resources for Classrooms",
      "Scholastic Book Fair",
    ],
  },
  {
    num: "02",
    title: "Arts, Culture & Enrichment",
    icon: "Palette",
    accent: "#FF007F",
    items: [
      "Assemblies and Guest Speakers",
      "Night of the Arts Showcase",
      "Cultural Club (Lunch Club)",
      "Garden Club (Lunch Club)",
      "Study Buddies (After School Club)",
    ],
  },
  {
    num: "03",
    title: "Student Activities & Wellness",
    icon: "HeartPulse",
    accent: "#EAB308",
    items: ["Mileage Club", "Goodwill Games", "Red Ribbon Week", "Safety Patrol"],
  },
  {
    num: "04",
    title: "Schoolwide Events & Family Engagement",
    icon: "PartyPopper",
    accent: "#B500FF",
    items: [
      "Welcome Back to School Ice Cream Social",
      "Family Nights",
      "Fall Carnival",
      "Eagle Extravaganza",
      "International Night",
      "End of the School Year Party in the Park",
      "6th Grade Graduation Food & Signs",
    ],
  },
  {
    num: "05",
    title: "Staff Appreciation",
    icon: "Heart",
    accent: "#F43F5E",
    items: [
      "Welcome Back to School Breakfast",
      "Staff Appreciation Week (it's awesome!)",
      "Staff Valentine's Day Bouquets/Flowers",
      "Staff Coffee in the Staff Lounge all Year",
    ],
  },
  {
    num: "06",
    title: "Gifts to the School",
    icon: "Gift",
    accent: "#00F5D4",
    items: ["New AV Tech in the MUR (2024/25 gift example)", "+ Many More"],
  },
  {
    num: "07",
    title: "Parent Engagement",
    icon: "Users",
    accent: "#38BDF8",
    items: ["Parent Education Nights", "Parent Hangouts/Outings"],
  },
];
